/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycProcessDto } from '../../models/kyc-process-dto';
import { KycProcessSubmitRequestDto } from '../../models/kyc-process-submit-request-dto';

export interface Submit$Params {
  id: string;
      body: KycProcessSubmitRequestDto
}

export function submit(http: HttpClient, rootUrl: string, params: Submit$Params, context?: HttpContext): Observable<StrictHttpResponse<KycProcessDto>> {
  const rb = new RequestBuilder(rootUrl, submit.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycProcessDto>;
    })
  );
}

submit.PATH = '/kyc/processes/{id}/submit';
